{
  "Admin": {
    "AdminAppointmentPage": {
      "cancelAppointment": "Êtes-vous sûr d'annuler le rendez-vous ?",
      "cannotDelay": "Uniquement les rendez-vous généralistes ayant été annulés automatiquement peuvent être décalés si cela n'impacte pas d'autres rendez-vous",
      "delayAppointment": "Êtes-vous sûr de décaler de 30 minutes le rendez-vous ?",
      "logHeader": "Historique",
      "tab": {
        "events": "Incidents",
        "feedback": "Formulaire post RDV",
        "form": "Informations",
        "informations": "Informations",
        "log": "Log",
        "sms": "SMS"
      }
    },
    "Appointment": {
      "appointmentTypeColor": {
        "CleaningAppointment": "blue",
        "MaintenanceAppointment": "red",
        "PatientAppointment": "green",
        "WorkAppointment": "red"
      },
      "consultation": {
        "false": "TC non faite",
        "null": "TC ?",
        "true": "TC faite"
      },
      "consultationColor": {
        "false": "blue",
        "null": "",
        "true": "lime"
      },
      "is_cancel": "Annulé",
      "menu": {
        "info": "Info",
        "log": "Logs",
        "sms": "SMS"
      },
      "state": {
        "auto_cancel": "Annulé automatiquement",
        "cancel": "Annulé",
        "clean_in_progress": "Fait - Nettoyage en cours",
        "done": "Fait",
        "in_progress": "En cours",
        "late": "En retard",
        "not_confirmed": "Non confirmé",
        "person_left": "Fait - Attente nettoyage",
        "problem": "Anomalie",
        "waiting": "Prévu"
      },
      "stateColor": {
        "auto_cancel": "#F48701",
        "cancel": "#FEBF71",
        "clean_in_progress": "#95C623",
        "done": "#95C623",
        "in_progress": "#262748",
        "late": "#AAAA4A",
        "not_confirmed": "#AAAA4A",
        "person_left": "#95C623",
        "problem": "#DD1C1A",
        "waiting": "#101026"
      },
      "type": {
        "CleaningAppointment": "Nettoyage",
        "MaintenanceAppointment": "Maintenance",
        "PatientAppointment": "Médical",
        "WorkAppointment": "Animation",
        "generalist": "Généraliste",
        "specialist": "Spécialiste"
      }
    },
    "AppointmentFilter": {
      "assigned": "Personne assignée",
      "box": "Box",
      "name": "Nom",
      "phone": "Téléphone"
    },
    "AppointmentForm": {
      "age": "Âge du patient",
      "age_extra": "Un accompagnement est requis si le patient à moins de 16 ans",
      "appointment_date": "Heure du rdv",
      "assigned": "Personne assignée",
      "box": "Box",
      "comment": "Commentaire",
      "consultation_done": "Téléconsultation",
      "createdBy": {
        "admin": "Vigilance",
        "label": "RDV pris via",
        "mairie": "Lien mairie",
        "qrcode": "QRcode",
        "web": "Site web"
      },
      "created_at": "Date de la réservation",
      "digicode": "Digicode",
      "email": "Email",
      "first_name": "Prénom",
      "interphone": "Interphone",
      "last_name": "Nom",
      "note": "Note",
      "phone": "Téléphone",
      "range": "Plage horaire",
      "specialistName": "Nom du spécialiste",
      "start": "Heure du RDV",
      "zip_code": "Code postal"
    },
    "AppointmentList": {
      "table": {
        "age": "Âge",
        "appointmentType": "Type",
        "assigned": "Assigné",
        "bookedAppointments": "Nombre de réservations",
        "box": "Box",
        "date": "Jour",
        "digicode": "Digicode",
        "infoBookedAppointments": "Le survol du chiffre permet de connaître les dates des rdv",
        "name": "Prénom Nom",
        "nextAppointment": "Prochain RDV sur cette box",
        "nextAppointmentEmpty": "Pas de prochain RDV sur cette box",
        "phone": "Téléphone",
        "previousAppointments": "Rendez-vous précédents du patient",
        "range": "Horaire",
        "state": "Status",
        "viewAppointment": "Voir"
      }
    },
    "AppointmentsPage": {
      "tab": {
        "allAppointments": "Tous",
        "canceledAppointments": "Annulés",
        "cleaningAppointments": "Nettoyage",
        "currentAppointments": "Actuels",
        "doneAppointments": "Faits",
        "maintenanceAppointments": "Maintenance",
        "nextAppointments": "Prévus",
        "patientAppointments": "Médical",
        "workAppointments": "Animation"
      },
      "title": "Rendez-vous"
    },
    "Box": {
      "availableNow": {
        "button": "Créer un rendez-vous immédiat",
        "title": "Box disponible immédiatement"
      },
      "level": {
        "error": "Anomalie",
        "maintenance": "Maintenance",
        "operation": "En service",
        "stopped": "Arrêt",
        "unknow": "Inconnu"
      },
      "menu": {
        "calendar": "Agenda",
        "cleaning": "Nettoyage",
        "cluster": "Grappe",
        "info": "Information",
        "logs": "Historique d'activités",
        "opening": "Paramétrage calendrier",
        "specialists": "Spécialistes"
      },
      "online": {
        "false": "Hors ligne",
        "true": "En ligne"
      },
      "state": {
        "busy": "Box occupée",
        "busy_calm_err": "511 : Box occupée - aucun mouvement",
        "busy_open_err": "510 : Box occupée - Porte ouverte",
        "cleaning": "Box en nettoyage",
        "cleaning_move_err": "531 : Box en nettoyage - détection de mouvement",
        "cleaning_no_watt_err": "530 : Box en nettoyage - Lampe éteinte",
        "empty_busy_2_err": "503 : Box vide et propre - Détection de mouvement sans ouverture de porte",
        "empty_busy_err": "501 : Box vide et propre - Détection de mouvement sans digicode",
        "empty_clean": "Box vide et propre",
        "empty_no_closed_err": "502 : Box vide et propre - Porte ouverte sans digicode",
        "empty_open_err": "500 : Box vide et propre - Porte ouverte",
        "empty_to_clean": "Box vide et à nettoyer",
        "maintenance": "Box en maintenance",
        "stopped": "Box en arrêt",
        "to_clean_open_err": "520 : Box vide et à nettoyer - Porte ouverte",
        "unknow": "Aucun",
        "work": "Box en animation"
      },
      "stateColor": {
        "busy": "lime",
        "busy_calm_err": "red",
        "busy_open_err": "red",
        "cleaning": "blue",
        "cleaning_move_err": "red",
        "cleaning_no_watt_err": "red",
        "empty_busy_2_err": "red",
        "empty_busy_err": "red",
        "empty_clean": "green",
        "empty_no_closed_err": "red",
        "empty_open_err": "red",
        "empty_to_clean": "cyan",
        "maintenance": "orange",
        "stopped": "purple",
        "to_clean_open_err": "red",
        "unknow": "grey",
        "work": "#08A4BD"
      }
    },
    "BoxCalendar": {
      "createPopupTitle": "Ajouter une Période",
      "periodTitle": {
        "cleaning": "Nettoyage",
        "consulting": "Consultations",
        "open": "Box ouverte"
      },
      "popupTitle": "Ajouter un RDV",
      "slotTitle": {
        "xl": {
          "closed": "Box fermée",
          "free": "Créneau disponible"
        },
        "xs": {
          "closed": "Fermé",
          "free": "Disponible"
        }
      },
      "updatePopupTitle": "Modifier une Période"
    },
    "BoxCleaningPage": {
      "appointments_count": "Nombre de RDV depuis dernier RDV nettoyage",
      "last_cleaning_informations": "Dernier RDV de nettoyage",
      "next_cleaning_informations": "Prochain RDV de nettoyage",
      "slots_count": "Nombre de créneau disponible depuis dernier RDV nettoyage",
      "week_cleaning_informations": "RDV nettoyage de la semaine"
    },
    "BoxClusterPage": {
      "searchPlaceholder": "Rechercher une commune...",
      "title": "Grappe de communes"
    },
    "BoxFilter": {
      "level": "Sélectionner un état",
      "name": "Nom",
      "online": "En ligne",
      "owner": "Sélectionner un propriétaire",
      "zipCode": "Code Postal"
    },
    "BoxForm": {
      "active": "Active",
      "address": "Adresse",
      "calendoc_id": "Calendoc ID",
      "city": "Ville",
      "cleaning_appointments_limit": "Maximum de RDV entre deux RDV de nettoyage",
      "cleaning_slots_limit": "Maximum de créneau entre deux RDV de nettoyage",
      "cleanup_code": "Code nettoyage",
      "comment": "Commentaire",
      "daily_code": "Code journalier",
      "emergency_code": "Code urgence",
      "extra_address": "Complément d'adresse",
      "gps": "Coordonnées GPS",
      "group": {
        "address": "Adresse",
        "contact": "Contact",
        "digicodes": "Digicodes",
        "interveners": "Intervenants",
        "maintenance": "Maintenance",
        "nordnet": "Nordnet",
        "tessan": "Tessan"
      },
      "inactive": "Inactive",
      "interphone": "Interphone",
      "lock_1": "Nettoyage (Gauche)",
      "lock_2": "Stockage (Droite)",
      "lock_3": "Électrique (Bas)",
      "lock_4": "Électronique (Haut)",
      "locks": "Cadenas",
      "name": "Nom",
      "nordnet_email": "Login  Nordnet",
      "nordnet_number": "Numéro Client Nordnet",
      "owner": "Propriétaire",
      "pcc_phone": "Téléphone PCC",
      "picture": "Image de la box",
      "pictureButton": "Choisir une image",
      "slot_schedule": "Décalage en minutes des créneaux",
      "teleconsulting_company": "Entreprise de téléconsultation",
      "tessan_login": "Login Tessan",
      "tessan_password": "Mot de passe Tessan",
      "waitingTime": "Image du temps d'attente",
      "zip_code": "Code postal"
    },
    "BoxInfoPage": {
      "collapseTitle": "Des informations sont manquantes",
      "title": "Informations de la box"
    },
    "BoxList": {
      "table": {
        "active": "Active - ",
        "address": "Adresse: Manquant!",
        "calendoc_id": "Identifiant Calendoc: Manquant!",
        "city": "Ville: Manquant!",
        "events": "Incidents",
        "gps_point": "Position GPS de la box: Manquante!",
        "inactive": "Inactive - ",
        "infoEvents": "le survol permet de voir la liste des incidents toujours ouverts",
        "infoOnline": "le survol permet de connaître la date du changement d'état",
        "interphone": "Numéro de l'interphone: Manquant!",
        "intervener_cleaning": "Intervenant de nettoyage: Manquant!",
        "intervener_emergency": "Intervenant des urgences: Manquant!",
        "intervener_maintenance": "Intervenant de maintenance: Manquant!",
        "intervener_municipacility": "Intervenant municipal: Manquant!",
        "intervener_territory_responsable": "Responsable territoire: Manquant!",
        "lastInfoOnline": "Dernière changement d'état",
        "lock_1": "Cadenas Nettoyage: Manquant!",
        "lock_2": "Cadenas Stockage: Manquant!",
        "lock_3": "Cadenas Électrique: Manquant!",
        "lock_4": "Cadenas Électronique: Manquant!",
        "name": "Nom",
        "nordnet_email": "Login Nordnet: Manquant!",
        "nordnet_number": "Numéro Client Nordnet: Manquant!",
        "online": "En ligne",
        "owner": "Propriétaire",
        "owner_id": "Propriétaire: Manquant!",
        "pcc_phone": "Numéro de téléphone de la box: Manquant!",
        "state": "État",
        "unresolvedEvents": "Incident(s) non résolu(s) pour cette box",
        "waiting_time": "Image du délai d'attente: Manquante!",
        "zipCode": "Code postal",
        "zip_code": "Code postal: Manquant!"
      }
    },
    "BoxesPage": {
      "addBoxTitle": "Ajouter une box",
      "maintenance": {
        "button": "Mettre en maintenance",
        "title": "Mise en Maintenance de toutes les Box"
      },
      "title": "éléments"
    },
    "Chat": {
      "attributes": {
        "owner": {
          "CleaningAppointment": "Intervenant",
          "Intervener": "Intervenant",
          "MaintenanceAppointment": "Intervenant",
          "PatientAppointment": "Patient",
          "WorkAppointment": "Intervenant"
        }
      },
      "close": "Clôturer la conversation"
    },
    "ChatList": {
      "appointment": "Horaire du RDV",
      "box": "Box",
      "date": "Date de la réponse",
      "owner": "Envoyeur",
      "summary": "Extrait"
    },
    "ChatsPage": {
      "tab": {
        "all": "7 derniers jours",
        "open": "Reçus"
      }
    },
    "Common": {
      "Logs": {
        "header": "Historique"
      }
    },
    "Event": {
      "attributes": {
        "content": "Description",
        "inCharge": "Responsable",
        "level2Ticket": "Action immédiate de Vigilance 2 requise",
        "tags": "Tags",
        "title": "Titre"
      },
      "businessArea": "Secteur d'activité :",
      "comments": "Commentaires",
      "create": "Un problème rencontré?",
      "createButton": "Créer un incident",
      "description": "Description",
      "list": "Incidents",
      "noTags": "Aucun Tag sélectionné",
      "notify_level_2": "SMS envoyé",
      "title": {
        "create": "Création d'un incident"
      },
      "unresolved": "Non résolu"
    },
    "EventFilter": {
      "box_id": "Box",
      "business_area_id": "Secteur d'activité",
      "day": "Aujourd'hui",
      "false": "Non",
      "family_id": "Famille",
      "inCharge": "Responsable",
      "month": "30 derniers jours",
      "name": "Nom du filtre",
      "newFilter": "Nouveau Filtre",
      "number": "Numéro d'incident",
      "period": "Période",
      "resolved": "Résolu",
      "tag_id": "Tag",
      "true": "Oui",
      "week": "7 derniers jours"
    },
    "EventList": {
      "addLevel2": "Création ticket pour niveau 2",
      "notification": {
        "activated": "Les notifications sont activées",
        "button": "Affichez les notifications"
      },
      "table": {
        "alert": "Alerte",
        "appointment": "Rdv",
        "box": "Box",
        "comment_count": "Commentaires",
        "comments": "Commentaires",
        "content": "Description",
        "createLevel2": "Action immédiate de Vigilance 2 requise",
        "created_at": "Date de création",
        "created_by": "Créé par",
        "created_since": "Créé depuis",
        "inCharge": "Responsable",
        "level2": {
          "content": "Description",
          "date": "Date & heure où l'incident a eu lieu",
          "title": "Titre",
          "url": "Lien utile"
        },
        "nobodyInCharge": "Aucun responsable",
        "notify_level_2": "Prévenir Vigilance 2",
        "number": "Numéro",
        "resolved": "Résolu",
        "resolved_at": "Date de résolution",
        "tag": "Tags",
        "teleconsulting_company": "Entreprise de téléconsultation",
        "title": "Titre",
        "treated_by": "Résolu par",
        "withoutAppointment": "Hors RDV"
      }
    },
    "FeedbackForm": {
      "unsavedChangesContent": "Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir quitter cette page ?",
      "unsavedChangesTitle": "Modifications non sauvegardées"
    },
    "GepetoData": {
      "daily_code": "Code journalier",
      "door_state": "Porte",
      "door_state_since": "État porte depuis",
      "git_version": "Version",
      "mouv1": "Mouvement 1",
      "mouv1_state": "État mouvement 1",
      "mouv2": "Mouvement 2",
      "mouv2_state": "État mouvement 2",
      "mouv3": "Mouvement 3",
      "mouv3_state": "État mouvement 3",
      "mouv4": "Mouvement 4",
      "mouv4_state": "État mouvement 4",
      "move_state": "Mouvement",
      "move_state_since": "État mouvement depuis",
      "plug_state": "Lampe",
      "plug_state_since": "État lampe depuis",
      "plug_watt": "Watt",
      "state": "État"
    },
    "GepetoFilter": {
      "name": "Nom",
      "zipCode": "Code Postal"
    },
    "GepetoList": {
      "command": {
        "busy": "Occupée",
        "cleaning": "Lancer le nettoyage",
        "empty_clean": "Vide et propre",
        "empty_to_clean": "Vide et à nettoyer",
        "maintenance": "Maintenance",
        "stopped": "En Arrêt",
        "voip_reboot": "Redémarrer interphone",
        "work": "Animation"
      },
      "table": {
        "box_state": "Etat Box",
        "command": "Commande",
        "data": "Données",
        "gepeto_state": "Etat Gepeto",
        "ip": "IP",
        "latency": "Latence",
        "name": "Nom",
        "version": "Version",
        "voip_state": "État interphone",
        "zipCode": "Code postal"
      }
    },
    "GepetoPage": {
      "acceptedKeys": "les touches autorisées sont 1,2,3,4,5,6,7,8,9,0 présent une seule fois, ne pas y renseigner la touche de validation",
      "allKeysAvailable": "Toutes les touches sont disponibles",
      "availableKeys": "Touches disponibles",
      "commands": "Actions",
      "data": "Données",
      "digicode": "Digicode",
      "endKey": "Touche de validation",
      "groupKeysAvailable": "Seules les touches sélectionnées sont disponibles",
      "network": "Réseau",
      "pingLog": "Latence",
      "title": "Gepeto",
      "version": "Version"
    },
    "GepetoVersion": {
      "gepeto": "Gepeto",
      "nodered": "NodeRed",
      "pfsense": "pfsense"
    },
    "GepetosPage": {
      "title": "éléments"
    },
    "Intervener": {
      "menu": {
        "info": "Info",
        "sms": "SMS"
      }
    },
    "IntervenerFilter": {
      "box": "Box",
      "job": "Fonction",
      "name": "Nom"
    },
    "IntervenerForm": {
      "aPhone": "un téléphone",
      "anEmail": "un email",
      "company": "Société",
      "description": "Description",
      "email": "Email",
      "emails": "Emails",
      "firstName": "Prénom",
      "job": {
        "cleaning": "Nettoyage",
        "emergency": "Secours",
        "hospital": "Hôpital",
        "label": "Fonction",
        "maintenance": "Maintenance",
        "municipacility": "Municipalité",
        "territory_responsable": "Responsable territoire"
      },
      "lastName": "Nom",
      "phone": "Téléphone",
      "phones": "Téléphones",
      "send_automatic_message": "Envoi des SMS de rappel"
    },
    "IntervenersList": {
      "table": {
        "boxes": "Intervient sur",
        "emails": "Emails",
        "job": {
          "cleaning": "Nettoyage",
          "emergency": "Secours",
          "hospital": "Hôpital",
          "label": "Fonction",
          "maintenance": "Maintenance",
          "municipacility": "Municipalité",
          "territory_responsable": "Responsable territoire"
        },
        "name": "Nom",
        "phones": "Téléphones"
      }
    },
    "IntervenersPage": {
      "addIntervenerTitle": "Création d'un intervenant",
      "deletePopupTitle": "Êtes-vous sûr de vouloir supprimer l'intervenant",
      "tab": {
        "active": "Actifs",
        "deleted": "Supprimés"
      }
    },
    "Login": {
      "commands": "Connection au logiciel de commandes",
      "email": "Email",
      "password": "Mot de passe"
    },
    "Logs": {
      "empty": "Il n'y a pas d'historique pour ce rendez-vous"
    },
    "Menu": {
      "appointments": "Rendez-vous",
      "appointments_dashboard": "Aujourd'hui",
      "appointments_history": "Historique",
      "boxes": "Box",
      "changelog": "Mise à jour",
      "chats": "SMS",
      "events": "Incidents",
      "gepetos": "Gepetos",
      "interveners": "Intervenants",
      "owners": "Propriétaires",
      "setup": "Paramétrage",
      "statistics": "Indicateurs",
      "tags": "Tags",
      "teleconsulting_companies": "Entr. Téléconsultation",
      "users": "Utilisateurs"
    },
    "OwnerForm": {
      "comment": "Commentaire",
      "contact": "Contact",
      "name": "Nom"
    },
    "OwnerList": {
      "table": {
        "boxes": "Box",
        "name": "Nom",
        "nbBoxes": "Nombre de box"
      }
    },
    "OwnersPage": {
      "addOwnerTitle": "Ajouter un propriétaire",
      "title": "Propriétaires"
    },
    "Period": {
      "create": "Une période d'ouverture manquante ?",
      "createButton": "Créer une période d'ouverture",
      "title": {
        "create": "Création d'une période d'ouverture de box"
      }
    },
    "PeriodForm": {
      "alreadyCreated": "La période d'ouverture pour cette journée est déjà créée",
      "intervener": "Intervenant",
      "noCleaningIntervener": "Veuillez assigner à cette Box Médicale un intervenant, avec un numéro de téléphone, pour le nettoyage",
      "period_type": {
        "cleaning": "Nettoyage",
        "consulting": "Consultations",
        "open": "Ouverture de la box"
      },
      "range": "Plage horaire"
    },
    "SmsPanel": {
      "error": {
        "content": "Code d'erreur : {{ status }}",
        "title": "Échec d'envoi de SMS"
      },
      "lbm_initial": "LBM",
      "select_phone": "Sélectionner un numéro",
      "select_template": "Choisir un SMS",
      "send_to": "Envoyé au "
    },
    "SpecialistList": {
      "name": {
        "DM": "Dermatologue",
        "GR": "Gériatrie",
        "PM": "Pneumologue"
      },
      "status": {
        "error": "Erreur Calendoc / Tessan empêchant la récupération des données",
        "in_progress": "Chargement en cours des disponibilités"
      },
      "table": {
        "appointments": "Horaire",
        "availabilities": "Disponibilité",
        "name": "Nom"
      }
    },
    "Statistic": {
      "AppointmentEventsChart": {
        "title": "RDV avec incident"
      },
      "CanceledChart": {
        "affectedByLate": "Affecté par un retard",
        "autoCanceled": "Annulés automatiquement",
        "canceled": "Annulés manuellement",
        "delayed": "A été décalé",
        "done": "Faits",
        "lateCanceled": "Annulé à cause d'un retard",
        "notConfirmed": "Non confirmé",
        "notPresented": "Pas présenté",
        "title": "RDV pris"
      },
      "PostalPlaceFilledChart": {
        "title": "RDV avec code postal"
      }
    },
    "Tag": {
      "500": "Anomalie 500",
      "501": "Anomalie 501",
      "502": "Anomalie 502",
      "503": "Anomalie 503",
      "510": "Anomalie 510",
      "511": "Anomalie 511",
      "520": "Anomalie 520",
      "530": "Anomalie 530",
      "531": "Anomalie 531",
      "CB": "Carte bancaire",
      "CV": "Carte vitale",
      "CV_forgotten": "Carte vitale oubliée",
      "RTS": "RTS",
      "SMS": "SMS",
      "account": "Compte internet",
      "air_conditionning": "Climatisation",
      "appointment": "RDV",
      "appointment_duration_update": "Augmentation de la durée des RDV",
      "appointment_incorrect_state": "RDV état incorrect",
      "appointment_update": "Mise à jour automatique RDV",
      "audio_issue": "Problème audio",
      "auto_canceled_appointment": "annulation RDV",
      "auto_intercom": "Ping interphone",
      "auto_sensor": "État capteurs mouvement",
      "automatic_cleaning": "Nettoyage automatique",
      "box_deconnection": "Box déconnectée",
      "box_incorrect_state": "Box état incorrect",
      "bug": "Bug",
      "businessArea": {
        "automatic": "Automatique",
        "internet": "Connexion internet",
        "other": "Autre",
        "reservation": "Réservation",
        "teleconsulting": "Téléconsultation",
        "telephony": "Téléphonie",
        "vigilance": "Vigilance"
      },
      "call": "Appel",
      "canceled_appointment": "RDV annulé",
      "cleaning_appointment": "RDV nettoyage",
      "communication": "Communication",
      "configuration": "Configuration",
      "daily_code": "Digicode journalier donné",
      "deconnection": "Déconnexion téléconsultation",
      "dermatoscope": "Dermatoscope",
      "digicode": "Digicode",
      "door": "Porte",
      "electricity": "Électricité",
      "family": {
        "RTS": "RTS",
        "anomaly": "Anomalie",
        "app_issue": "Application téléconsultation",
        "call": "Appel",
        "callback": "Automatisme",
        "company": "Entreprise de téléconsultation",
        "gepeto": "Logiciel box",
        "gepeto_devices": "Équipement LBM",
        "job": "Asynchrone",
        "material": "Matériel",
        "medical_devices": "Dispositifs médicaux",
        "other": "Autre",
        "reservation_sms": "SMS réservation",
        "reservation_specialist": "Réservation spécialiste",
        "satellite": "Satellite",
        "supervision": "Supervision",
        "vigilance_appointment": "Rendez-vous",
        "visio_issue": "Téléconsultation"
      },
      "feedback": "Retour patient",
      "gepeto_configuration": "Configuration Gepeto",
      "headphone": "Haut-parleurs",
      "history": "Historique",
      "immediate": "RDV immédiat",
      "information": "Information",
      "intercom": "Interphone",
      "internet_deconnection": "Coupure internet",
      "late_appointment": "RDV en retard",
      "lights": "Lumières",
      "microphone": "Micro",
      "missed_cleaning_appointment": "RDV nettoyage non réalisé",
      "missing_doctor": "Absence médecin",
      "not_connected": "Appareils déconnectés",
      "other": "Autre",
      "otoscope": "Otoscope",
      "oximeter": "Oxymètre / Saturomètre",
      "patient": "Patient",
      "printer": "Imprimante",
      "sensor": "Capteurs mouvement",
      "sms": "SMS vigilance",
      "sms_api_fail": "Échec api SMS",
      "specialist": "Médecin spécialiste",
      "specialist_api_fail": "Échec api spécialiste",
      "specialist_reservation": "Réservation spécialiste",
      "stethoscope": "Stéthoscope",
      "support": "Support",
      "tablet": "Tablette",
      "teleconsulting_account": "Compte patient",
      "telephony_app": "Application téléphonie",
      "tensiometer": "Tensiomètre",
      "thermometer": "Thermomètre",
      "unconfirmed_appointment": "RDV non confirmé",
      "unfinished_appointment": "Clôture RDV",
      "waiting_time": "Temps d'attente"
    },
    "TagsPage": {
      "appointment_state": "États du rendez-vous",
      "appointment_type": "Types de rendez-vous",
      "box_state": "États de la box",
      "event_tags": "Tags des incidents"
    },
    "TeleconsultingCompaniesPage": {
      "addTitle": "Ajouter une entreprise de téléconsultation",
      "title": "Entreprises de téléconsultation"
    },
    "TeleconsultingCompanyForm": {
      "increased_slot_duration": "Augmentation de la durée des rendez-vous",
      "minimum_age": "Âge minimum",
      "name": "Nom",
      "url": "Lien de création de compte"
    },
    "TeleconsultingCompanyList": {
      "table": {
        "increased_slot_duration": "Augmentation de la durée des rendez-vous",
        "minimum_age": "Âge minimum",
        "name": "Nom",
        "url": "Lien de création de compte"
      }
    },
    "TeleconsultingCompanyPage": {
      "title": "Entreprise de téléconsultation"
    },
    "Time": {
      "unit": {
        "day": "j",
        "hour": "h",
        "minute": "m"
      }
    },
    "UpdatePassword": {
      "password": "Nouveau mot de passe",
      "passwordConfirmation": "Confirmer le mot de passe"
    },
    "User": {
      "role": {
        "admin": "Administrateur",
        "collectivity": "Collectivité",
        "setup": "Paramétrage",
        "supervisor": "Superviseur",
        "user": "Utilisateur"
      }
    },
    "UserForm": {
      "email": "Email",
      "firstName": "Prénom",
      "lastName": "Nom",
      "owner": "Propriétaire",
      "role": "Rôle"
    },
    "UserList": {
      "table": {
        "email": "Email",
        "firstName": "Prénom",
        "lastName": "Nom",
        "roles": "Rôles"
      }
    },
    "UsersPage": {
      "addUserTitle": "Ajouter un utilisateur",
      "deletePopupTitle": "Êtes-vous sûr de vouloir supprimer l'utilisateur",
      "tab": {
        "active": "Actifs",
        "deleted": "Supprimés"
      },
      "title": "Utilisateurs"
    },
    "btn": {
      "back": "Retour",
      "cancel": "Annuler le RDV",
      "delay": "Décaler le RDV",
      "leave": "Quitter",
      "save": "Sauvegarder",
      "stay": "Rester",
      "submit": "Valider"
    },
    "message": {
      "error": {
        "create": "Une erreur est survenue lors de la création",
        "delete": "Une erreur est survenue lors de la suppression",
        "get": "Une erreur est survenue lors de la récupération des données",
        "login": "Une erreur est survenue lors de l'authentification",
        "password_update": "Une erreur est survenue lors du changement du mot de passe",
        "update": "Une erreur est survenue lors de la mise à jour"
      },
      "no": "Non",
      "success": {
        "create": "Création effectuée avec succès",
        "delete": "Suppression effectuée avec succès",
        "login": "Vous êtes connecté",
        "password_update": "Votre mot de passe a été édité avec succès, vous êtes maintenant connecté.",
        "update": "Mise à jour effectuée avec succès"
      },
      "updateError": "Une erreur est survenue lors de la mise à jour",
      "updateSuccess": "Mise à jour effectuée avec succès",
      "yes": "Oui"
    },
    "notification": {
      "appointment": {
        "cancel": "Annulation d'un RDV",
        "confirmation": "Nouveau RDV",
        "created": "Création d'un RDV",
        "late": "En retard",
        "link": "Voir le RDV"
      },
      "event": {
        "link": "Voir Incident",
        "type": {
          "closed_event": "Fermeture Incident",
          "new_event": "Nouvel Incident",
          "update_event": "Mise à jour Incident"
        }
      },
      "intervener": {
        "link": "Voir l'intervenant RDV"
      },
      "message": {
        "new_message": "Nouveau SMS"
      }
    }
  },
  "Public": {
    "Appointment": {
      "age": "Âge du patient",
      "age_error": "La téléconsultation n'est pas disponible pour les enfants de moins de {{minimumAge}} ans",
      "age_extra": "Un accompagnement est requis si le patient à moins de 16 ans",
      "cgu_1": "J'accepte les ",
      "cgu_2": "conditions générales d'utilisation",
      "civility": "Civilité",
      "country": "Pays",
      "email": "Email",
      "firstName": "Prénom",
      "lastName": "Nom",
      "minorConfirmation": {
        "cancelText": "Je refuse",
        "content": "Pour bénéficier d'une prise en charge par la CNAM, vous devez lier votre compte {{teleconsultingCompany}} (créable dans les prochaines étapes) à celui du titulaire de la carte de sécurité sociale (votre parent ou tuteur). Cela permet une lecture instantanée de vos droits lors de l'utilisation !",
        "okText": "J'ai lu et comprends",
        "title": "Vous avez moins de 18 ans et êtes toujours rattaché à la carte vitale d'un tiers ?"
      },
      "phone": "Téléphone",
      "submit": "Confirmer",
      "zip_code": "Code postal"
    },
    "BoxList": {
      "allAppointments": "Voir tous les horaires",
      "change": "Changer",
      "nearestBox": "Box les plus proches de",
      "noBox": "Aucune Box Médicale disponible autour de cette localisation",
      "now": "RDV immédiat",
      "selectBox": "Sélectionnez une Box Médicale",
      "today": "aujourd'hui"
    },
    "BoxPage": {
      "availableNow": {
        "button": "Obtenir un digicode",
        "description": "Cliquez pour obtenir un digicode et rentrer dans la Box Médicale dès maintenant",
        "title": "Box disponible immédiatement"
      },
      "change": "Changer",
      "description": "Vous avez demandé un rendez-vous ce jour à {{date}}, vous avez 10 minutes pour finaliser votre inscription et obtenir votre digicode",
      "faq": "FAQ",
      "more": "Afficher les créneaux suivants",
      "now": "Maintenant",
      "title": "Sélectionnez un rendez-vous",
      "unavailable": "RDV indisponible"
    },
    "CancelAppointmentPage": {
      "title": "Rendez-vous annulé !"
    },
    "ConfirmAppointmentForm": {
      "error": "Code invalide ou expiré",
      "resend": "Renvoyer le code",
      "resendSuccess": "Code renvoyé avec succès",
      "submitConfirmation": "Confirmer le numéro",
      "title": "Vous disposez de 15 minutes pour saisir le code SMS reçu pour confirmer votre numéro de téléphone"
    },
    "ConfirmAppointmentPage": {
      "title": "Confirmez votre rendez-vous"
    },
    "ConfirmedAppointment": {
      "Medadom": {
        "button": "Créer votre compte Medadon",
        "description": "Pour gagner du temps vous pouvez d'ores et déjà, si ce n'est pas déjà le cas, créer votre compte Medadon qui sera nécessaire pour la téléconsultation via ce lien"
      },
      "Tessan": {
        "button": "Créer votre compte Tessan",
        "description": "Pour gagner du temps vous pouvez d'ores et déjà, si ce n'est pas déjà le cas, créer votre compte Tessan qui sera nécessaire pour la téléconsultation via ce lien"
      },
      "cancel": "Annuler le rendez-vous",
      "canceled": "Votre rendez-vous a été annulé",
      "description": "Le digicode permettant d'ouvrir la porte est",
      "done": "Votre rendez-vous a été réalisé",
      "information": {
        "line1": "L'équipe de la Box Médicale est à votre disposition pour toute assistance au {{pcc_phone}} ou en utilisant l'interphone dans la Box Médicale ou en nous contactant par email ",
        "line2": "Assurez-vous de bien fermer la porte une fois dans la Box Médicale. Vous aurez besoin de votre carte vitale.",
        "line3": "Si vous devez faire l'avance de la part complémentaire, vous devez prévoir une CB."
      },
      "modalConfirm": "Êtes vous sûr de vouloir annuler votre rendez-vous ?",
      "ongoing": "Votre rendez-vous est en cours",
      "timeout": "Merci pour votre réservation, nous vous confirmerons votre réservation avec un second message"
    },
    "ConfirmedAppointmentPage": {
      "title": "Félicitations, rendez-vous confirmé !"
    },
    "CreateAppointmentPage": {
      "title": "Confirmez votre rendez-vous"
    },
    "ErrorPage": {
      "403": {
        "description": "Vous n'avez pas les droits pour accéder à cette page",
        "title": "Accès refusé"
      },
      "404": {
        "description": "La page que vous cherchez n'existe pas",
        "title": "Page non trouvée"
      },
      "422": {
        "description": "Une erreur est survenue, veuillez vérifier les informations saisies",
        "title": "Erreur de validation"
      },
      "500": {
        "description": "Une erreur est survenue, veuillez réessayer plus tard",
        "title": "Erreur serveur"
      },
      "box_inactive": {
        "description": "La Box Médicale de {{name}} ouvrira d'ici quelques jours",
        "title": "La Box Médicale n'est pas encore ouverte"
      },
      "maintenance": {
        "description": "Nous sommes désolé de la gêne occasionnée, le site est en cours de maintenance et sera opérationnel sous peu.",
        "title": "Le site est en maintenance"
      }
    },
    "Search": {
      "placeholder": "Ville / Code postal",
      "required": "Ce champ est requis",
      "submit": "Rechercher",
      "title": "Trouvez la Box Médicale la plus proche"
    },
    "Specialist": {
      "appointmentSelection": "Sélection du créneau",
      "appointmentsAvailable": "Créneaux disponibles",
      "automatic": "Choix automatique",
      "dateSelection": "Sélectionnez une date",
      "empty": "Aucun spécialiste disponible",
      "loading": "Chargement des spécialistes",
      "noAppointments": "Aucun créneau disponible",
      "selectReason": "Sélectionnez d'abord un type de RDV",
      "selectSpecialist": "Spécialiste"
    },
    "TimeoutAppointmentPage": {
      "title": "Réservation en cours"
    }
  },
  "actions": {
    "add": "Ajouter",
    "cancel": "Annuler",
    "comment": "Commenter",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "login": "Se connecter",
    "save": "Sauvegarder",
    "search": "Rechercher",
    "validate": "Valider"
  },
  "message": {
    "error": "Une erreur est survenue"
  },
  "rules": {
    "email": "Email invalide",
    "required": "Ce champ est requis"
  }
}
